"use client";
import React, {Fragment} from "react";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Center,
  Icon,
  HStack,
  Text,
} from "@chakra-ui/react";
import {FaMinus, FaPlus} from "@onemind-services-llc/react-icons-ng/fa";
import {TEXT_VARIANTS} from "@/theme/components/text";

export type AccordionProps = {
  title: string;
  content: React.ReactNode;
};

const AccordionComponent = (props: AccordionProps) => {
  const {content, title} = props;
  return (
    <Accordion allowToggle>
      <AccordionItem
        borderColor={"#ccc"}
        borderRadius={"8px"}
        borderWidth={"1px"}
        p={"7px 7px 7px 0"}
      >
        {({isExpanded}) => (
          <Fragment>
            <ButtonComponent isExpanded={isExpanded} title={title} />
            <AccordionPanel py={4}>
              {typeof content === "string" ? (
                <Text
                  variant={TEXT_VARIANTS.BODY2}
                  color="text.100"
                  whiteSpace={"pre-line"}
                >
                  {content}
                </Text>
              ) : (
                content
              )}
            </AccordionPanel>
          </Fragment>
        )}
      </AccordionItem>
    </Accordion>
  );
};

export default AccordionComponent;

const ButtonComponent = (props: {isExpanded: boolean; title: string}) => {
  const {isExpanded, title} = props;
  return (
    <AccordionButton _hover={{}}>
      <HStack justify={"space-between"} w={"full"}>
        <Text fontWeight={500} textAlign={"left"} variant={TEXT_VARIANTS.BODY2}>
          {title}
        </Text>
        <Center bg={"#6ec1e4"} borderRadius={"50%"} h={"25px"} w={"25px"}>
          <Icon
            as={isExpanded ? FaMinus : FaPlus}
            color={"whiteAlpha.900"}
            fontSize={isExpanded ? "20px" : "18px"}
            maxW={"25px"}
            minW={"25px"}
          />
        </Center>
      </HStack>
    </AccordionButton>
  );
};
